import React from "react";

const ConfirmButton = ({ action }) => {
  return (
    <div
      style={{
        marginTop: 10,
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <button
        style={{
          marginTop: 5,
          border: "none",
          color: "white",
          backgroundColor: "green",
          height: 40,
          borderRadius: 5,
          width: "50%",
          fontWeight: "700",
        }}
        onClick={action}
      >
        Confirm
      </button>
    </div>
  );
};

export default ConfirmButton;
